import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link } from "@reach/router";
import { useEthers } from "@usedapp/core";
import { LoadingModal } from "../ui/Modals";
import { useContractContext } from "../../hooks/useContractContext";

// for owner view

const Outer = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 8px;
`;

const NavLink = (props) => (
  <Link
    {...props}
    getProps={({ isCurrent }) => {
      // the object returned here is passed to the
      // anchor element's props
      return {
        className: isCurrent ? "active" : "non-active",
      };
    }}
  />
);

const Responsive = () => {
  const { copyrightsContract } = useContractContext();
  const { activateBrowserWallet, account } = useEthers();
  const [smartContractData, setSmartContractData] = useState([]);
  const [noArtworkDetected, setNoArtworkDetected] = useState(false);

  const [nftData, setNftData] = useState({
    nfts: [].slice(0, 8),
    height: 0,
  });

  const formatIpfsUrl = (url) => {
    return url.replace(/ipfs:\/\//g, "https://nftstorage.link/");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        var numTokensOwned = Number(
          await copyrightsContract.balanceOf(account)
        );
        if (numTokensOwned === 0 || numTokensOwned < 0) {
          setNoArtworkDetected(true);
        }
        else if (numTokensOwned > 0) {
          setNoArtworkDetected(false);
        }
      } catch (err) {
        setNoArtworkDetected(true);
        console.log(err);
        return;
      }
      const tempArray = [numTokensOwned - 1];
      // loop over tokenIDs to pull data from both copyrights_contract & Marketplace_contract
      for (
        let pictureIndex = 0;
        pictureIndex < numTokensOwned;
        pictureIndex++
      ) {
        var tokenId = await copyrightsContract.tokenOfOwnerByIndex(
          account,
          pictureIndex
        );
        var tokenWorkDetails = await copyrightsContract.checkDetailsOfWork(
          tokenId
        );
        tempArray[pictureIndex] = { tokenId, tokenWorkDetails };
      }
      // save data into a constant that can be passed to other components
      setSmartContractData(tempArray);
    };
    if (account) {
      fetchData();
    } else {
      activateBrowserWallet();
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account]);

  useEffect(() => {
    setNftData((prevState) => ({
      ...prevState,
      nfts: smartContractData.slice(0, 8),
    }));
  }, [smartContractData]);

  function onImgLoad({ target: img }) {
    let currentHeight = nftData.height;
    if (currentHeight < img.offsetHeight) {
      setNftData((prevState) => ({ ...prevState, height: img.offsetHeight }));
    }
  }

  function loadMore() {
    const nftState = nftData.nfts;
    const end = nftState.length + 4;
    setNftData((prevState) => ({
      ...prevState,
      nfts: smartContractData.slice(0, end),
    }));
  }

  return (
    <div className="row">
      {!account && (
        <div>
          Unable to detect a wallet. Please connect your wallet and try again.
        </div>
      )}
      {account && !noArtworkDetected && smartContractData.length === 0 && (
        <LoadingModal title={"Loading Data..."} />
      )}
      {account && noArtworkDetected && !smartContractData && (
        <div>No Copyright registrations detected in your wallet</div>
      )}
      {noArtworkDetected === false &&
        nftData.nfts.map((nft, index) => (
          <div
            key={index}
            className="d-item col-lg-3 col-md-6 col-sm-6 col-xs-12"
          >
            <div className="nft__item">
              <div
                className="nft__item_wrap"
                style={{ height: `${nftData.height}px` }}
              >
                <Outer>
                  <span>
                    <NavLink to={`/ManageRecord/${nft.tokenId}`}>
                      <img
                        onLoad={onImgLoad}
                        src={
                          nft.tokenWorkDetails === undefined
                            ? ""
                            : formatIpfsUrl(nft.tokenWorkDetails.workIpfsCid)
                        }
                        className="lazy nft__item_preview"
                        alt=""
                      />
                    </NavLink>
                  </span>
                </Outer>
              </div>
              <div className="nft__item_info">
                <div>
                  <b>TokenID</b> : {`${nft.tokenId}`}
                </div>
                <div>
                  <b>Creator</b> :{" "}
                  {`${
                    nft.tokenWorkDetails === undefined
                      ? ""
                      : nft.tokenWorkDetails.creatorPseudonym
                  }`}
                </div>

                <div className="nft__item_price">
                  {nft.price}
                  <span>{""}</span>
                </div>
                <div className="nft__item_action">
                  <NavLink to={`/ManageRecord/${nft.tokenId}`}>
                    <span>Manage</span>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        ))}
      {nftData.nfts.length !== smartContractData.length && (
        <div className="col-lg-12">
          <div className="spacer-single"></div>
          <span onClick={() => loadMore()} className="btn-main lead m-auto">
            Load More
          </span>
        </div>
      )}
      {noArtworkDetected && <span>no artwork detected</span>}
    </div>
  );
};

export default Responsive;
